import { HOSTNAME_WITH_PROTOCOL } from '~constants/config'

export const getUrlForPublicEventList = (eventListId: string) => {
  return `${HOSTNAME_WITH_PROTOCOL}/l/${eventListId}`
}
